import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuInd:0,
  },
  mutations: {
    setIndex(state,n){
      state.menuInd = n
    },
  },
  actions: {
    setMenuInd(context,index){
      context.commit("setIndex", index);
    },
  }
})
